import { TemplateTypes } from '../../../../../../../lib/models/TemplateTypes';
import { isIndexFound } from '../../../../../../../lib/util/helpers';

const getPageChapterId = (allChapters, pageId) => allChapters?.find(chapter => chapter?.chapterInnerPagesIds?.includes(pageId))?.id ?? null;

/**
 * Adds the page the user leaves to the end of the history. When the user goes back to a page on the current path
 * ("Back", or a button leading to an earlier page), that page and the ones after it in the same chapter are marked
 * `isAbandoned`: they stay to restore the pages, but until passed forward again they are an abandoned branch
 * (the HVM result skips their answers). Going to an abandoned page is a step forward and marks nothing, and so is
 * the chapters overview, which is revisited after every chapter.
 */
export function addPageToHistory(pageHistory, leftPage, { nextPageId, allChapters = [] } = {}) {
  const updatedHistory = [...pageHistory.filter(page => page.id !== leftPage.id), leftPage];
  const nextPageIndex = updatedHistory.findIndex(page => page.id === nextPageId);
  const nextPage = updatedHistory[nextPageIndex];

  if (!isIndexFound(nextPageIndex) || nextPageId === leftPage.id || nextPage.isAbandoned || nextPage.templateType === TemplateTypes.CHAPTER) {
    return updatedHistory;
  }

  const nextPageChapterId = getPageChapterId(allChapters, nextPageId);

  return updatedHistory.map((page, index) =>
    index >= nextPageIndex && getPageChapterId(allChapters, page.id) === nextPageChapterId ? { ...page, isAbandoned: true } : page
  );
}

export function setHistoryPages(allPages, currentPageId, currentElementsIds, setPageHistory, lastCurrentFlowElement, navigation = {}) {
  const currentPage = allPages.find(page => page.id === currentPageId);
  const currentFlowPage =
    currentPage?.templateType === TemplateTypes.PAGE
      ? { ...currentPage, elements: currentPage?.elements.filter(el => currentElementsIds.includes(el.id)) }
      : currentPage;

  setPageHistory(prevHistory => addPageToHistory(prevHistory, { ...currentFlowPage, lastCurrentFlowElement }, navigation));
}
